import React, { useEffect, useRef, useState, useMemo } from 'react';
import { isDate } from 'date-fns';
import {
	Button, Card, CloseButton, Col, Form, Modal, Row,
} from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import AsyncSelect from 'react-select/async';
import { toJS } from 'mobx';
import Calendar from 'react-calendar';
import uuid from 'react-uuid';
import { observer } from 'mobx-react';
import style from './TabResults.module.less';
import FileInput, { FileView } from '../../../UI/upload/FileInput';
import HorizontalDivider from '../../../common/HorizontalDivider';
import MileStoneEdit from './MileStoneEdit';
import DatePickerComponent from '../../../common/DatePickerComponent';
import { monthsArray } from '../../../../stores/StratProject/StrategyStore';
import '../../../../../style/Calendar.less';
import { useOutsideBounder } from '../../../../hooks/useOutsideClick';
import StatusBadge from '../../../common/StatusBadge';
import { filterPersonWithProjects, status } from '../../../../helpers/StrategyProject/stratProjectHelpers';
import ConfirmModal from '../../../common/ConfirmModal';
import TooltippedElement from '../../../common/TooltippedElement';
import { isAdmin } from '../../../../services/rolesSvc';
import Select from 'react-select';
import Required from '../../../Required';
import { years } from '../../../../helpers';
import YearSelect from '../../../common/YearSelect';
import { PlusLg } from 'react-bootstrap-icons';
import PersonsInChargeModal from './PersonsInChargeModal';
import ImpactProjectsModal from './ImpactProjectsModal';
import { getName } from '../../../../helpers/passport';
import { useStore } from '../../../../stores/StoreHelpers';
import { ProjectsFacts } from './ProjectsFacts';
import MilestoneFilesModal from '../../../project/PassportRead/MilestoneFilesModal';

export const ResultCardForm = observer(({
	edit, index, value, options, onChange, onDelete, onDeleteFile, userCtx, projects, closedPeriods
}) => {
	const [mileStones, setMileStones] = useState(toJS((value.milestones || []).slice().sort((x, y) => Number(x.orderNum) - Number(y.orderNum))));
	const [files,setFiles] = useState(value?.files ?? [])
	const [confirmModalOpen, setConfirmModalOpen] = useState(false);
	const [activeMilestone, setActiveMilestone] = useState(null);
	const [personsInChargeModalShow, setPersonInChargeModalShow] = useState(false);
	const [impactProjectsModalShow, setImpactProjectsModalShow] = useState(false);
	const dateRef = useRef(null);
	const store = useStore()
	const projectDisabledStatus = (() => {
		if (isAdmin(userCtx)) return false;
		return (value.status === status.approved || value.status === status.onProjOffice || value.status === status.declined);
	})();
	useOutsideBounder(dateRef);
	const handleUpdateMileStone = (...args) => {
		let [element, id, name] = args;

		if ([element, id , name].includes(undefined)) throw new Error(`Element ${element} or Id ${id} or Name ${name} is undefined`);
		setMileStones(prevState => prevState.map((x, y) => {
			if (id === x[typeof id === 'string' ? 'key' : 'id']) {
				if (isDate(element)) {
					if (name.toString().toLowerCase() === 'dateplan') {
						x.monthPlan = element.getMonth();
						x.yearPlan = element.getFullYear();
					} else {
						x.monthFact = element.getMonth();
						x.yearFact = element.getFullYear();
					}
					element = `${monthsArray[element.getMonth()]} ${element.getFullYear()}`;
				}
				return { ...x, [name]: element };
			}
			return x;
		}));
	};

	const handleDeleteMileStone = (element) => {
		setMileStones(mileStones.filter((x) => x?.key !== element?.key || x?.id !== element?.id));
	};
	const handleAddMileStone = () => {
		setMileStones([...value.milestones, {
			comment: '',
			name: '',
			key: uuidv4(),
			strategyId: Number(options.stratId),
			status: null,
			num: mileStones.length + 1,
			ygtPlan: '',
			datePlan: '',
			personsInCharge: [],
			projs: [],
			files: [],
			parent: null,
			parentId: null,
			trl: null,
			trlFactId: null,
			trlId: null,
			yearFact: null,
			yearPlan: null,
			monthPlan: null,
			monthYear: null,
			result: '',
			proveDocuments: [],
		}]);
	};

	useEffect(() => {
		onChange(mileStones, value.id || value.key, 'milestones');
	}, [mileStones]);

	const monthsOptions = useMemo(() => monthsArray.map(((month, i) => ({value: i, label: month}))), [])
	const disabled = useMemo(() => (closedPeriods || []).includes(value.yearPlan), [closedPeriods])

	return (
		<>
			<Card className={style.rowResult}>
				<Card.Header className={style.header}>
					<div>
						Результат
						{value?.orderNum ?? index + 1}
					</div>
					<div style={{ display: 'flex', gap: '20px' }}>
						<StatusBadge
							type='resultState'
							status={value.status ?? 'inProgress'}
						/>
						{!edit && !disabled && (
							<div
								onClick={() => {
									!!value.status && value.status !== 'isCreating'
										? setConfirmModalOpen(!confirmModalOpen)
										: onDelete()
								}}
								className={style.closeButton}
							/>
						)}
					</div>
				</Card.Header>
				<Card.Body>
					<Row className={style.rowResult}>
						<Form.Group as={Col}>
							<Form.Label data-required={edit ? 'false' : 'true'}>
								Название результата
							</Form.Label>
							<Form.Control
								disabled={edit || disabled}
								name='name'
								value={value.name}
								onChange={e => onChange(e.target.value, value.id || value.key, e.target.name)}
								maxLength={300}
								required
								as='textarea'
								placeholder='Макс. 300 символов'
							/>
						</Form.Group>
					</Row>
					<Row className={style.rowResult}>
						<Form.Group as={Col} xs={7}>
							<Form.Label>
								УГТ(план)
								<TooltippedElement
									iconSize='18px'
									tooltip='Уровень готовности технологии'
								/>
							</Form.Label>
							{/* <Form.Control disabled={edit} name={`trlId`} value={value['trlId'] && options.ygt[value['trlId']-1].id}  onChange={(e)=>onChange(+e.target.value||null,index,e.target.name)}  required as={'select'}> */}
							{/*    <option defaultChecked value={null} selected={value['trlId']===null}>Не указан</option> */}
							{/*    {options.ygt.map(elem=><option selected={Number(elem.id)+1 === +value['trlId']} value={Number(elem.id)}>{elem.descr}</option>)} */}
							{/* </Form.Control> */}
							<div>
								{!edit && !disabled ? (
									<AsyncSelect
										value={
											value.trlId
												? {
													value: options.ygt[value.trlId].id,
													label: options.ygt[value.trlId]?.descr,
												}
												: { value: null, label: 'Не указано' }
										}
										defaultOptions={options.ygt.map(elem => ({
											value: elem.id,
											label: elem.descr,
										}))}
										// loadOptions={options.getOptions}
										onChange={e => onChange(e.value, value.id || value.key, 'trlId')}
									/>
								) : (
									<Form.Control
										disabled
										value={
											value.trlId
												? options.ygt[value.trlId].descr
												: 'Не указано'
										}
									/>
								)}
							</div>
						</Form.Group>
						<Form.Group as={Col} xs={5}>
							<Form.Label>
								Дата выполнения (план) <Required />
							</Form.Label>
							<Row>
								<Col xs={5}>
									{edit || disabled ?
										<Form.Control value={value.yearPlan} readOnly/> :
										<YearSelect year={value.yearPlan}
													years={years.filter(year => year >= 2023 && !closedPeriods.includes(year))}
													onChange={year => onChange(year.value, value.id || value.key, 'yearPlan')}
										/>
									}
								</Col>
								<Col xs={7}>
									{edit || disabled ?
										<Form.Control readOnly value={monthsArray[value.monthPlan]}/> :
										<Select
											options={monthsOptions}
											value={monthsOptions.find(
												(opt, i) => i === value.monthPlan
											)}
											onChange={month => onChange(month.value, value.id || value.key, 'monthPlan')}
											placeholder="Выберите месяц"
										/>
									}
								</Col>
							</Row>
						</Form.Group>
					</Row>
					{edit && (
						<Row className={style.rowResult}>
							<Form.Group as={Col} xs={7}>
								<Form.Label data-required='true'>
									УГТ(Факт)
									<TooltippedElement
										iconSize='18px'
										tooltip='Уровень готовности технологии'
									/>
								</Form.Label>
								<div>
									{!(projectDisabledStatus || options.mileStoneId) ? (
										<AsyncSelect
											value={
												value.trlFactId
													? {
														value: options.ygt[value.trlFactId].id,
														label: options.ygt[value.trlFactId].descr,
													}
													: { value: null, label: 'Не указано' }
											}
											defaultOptions={options.ygt.map(elem => ({
												value: elem.id,
												label: elem.descr,
											}))}
											// loadOptions={options.getOptions}
											onChange={e => onChange(e.value, value.id || value.key, 'trlFactId')}
										/>
									) : (
										<Form.Control
											disabled
											value={
												value.trlFactId
													? options.ygt[value.trlFactId].descr
													: 'Не указано'
											}
										/>
									)}
								</div>
							</Form.Group>
							<Form.Group as={Col} xs={5}>
								<Form.Label>
									Дата выполнения (факт) <Required />
								</Form.Label>
								<Row>
									<Col xs={5}>
										{!(projectDisabledStatus || options.mileStoneId) ? <YearSelect year={value.yearFact} years={years} onChange={year => onChange(year.value, value.id || value.key, 'yearFact')} /> : <Form.Control value={value.yearFact || '-'} readOnly/>}
									</Col>
									<Col xs={7}>
										{!(projectDisabledStatus || options.mileStoneId) ? <Select
												options={monthsOptions}
												value={monthsOptions.find(
													(opt, i) => i === value.monthFact
												)}
												onChange={month => onChange(month.value, value.id || value.key, 'monthFact')}
												placeholder="Выберите месяц"
											/> :
											<Form.Control value={monthsArray[value.monthFact] || '-'} readOnly/>}
									</Col>
								</Row>
							</Form.Group>
						</Row>
					)}
					<Row className={style.rowResult}>
						{(value.personsInCharge && value.personsInCharge.length > 0 || value.projs && value.projs.length > 0) &&
							<div className={style['personsinCharge']}>
								<h2 style={{textAlign: 'left', fontSize: 16, marginBottom: 8,  color: '#212529'}}>Ответственные за достижение:</h2>
								<ul className={style['personsInCharge-list']} style={{marginBottom: edit ? 0 : 24}}>
									{value.personsInCharge && value.personsInCharge.length > 0 && value.personsInCharge.filter(person => !person.projId).map((person) => <li className={style['personsInCharge-item']} key={person.id}>
										{getName(person)}
										{!edit && !disabled && <button
											className='btn-close'
											style={{width: 13, height: 13, padding: 0}}
											onClick={() => onChange(value.personsInCharge.filter((v) => v.id !== person.id), value.id || value.key, 'personsInCharge')}
										/>}
									</li>)}
									{value.projs && value.projs.length > 0 && value.projs.map(proj =>
									{
										const project = projects.find((value) => value.originId === proj.originId)
										const personInCharge = value.personsInCharge.find(person => person.projId === proj.id)
										return project && <li className={style['personsInCharge-item']} key={`proj-${project.originId}`}>
											<p>
												{project.fullNumber} {project.name} <span style={{color: '#7F7F7F', marginLeft: 16, marginRight: 16}}>{personInCharge ? getName(personInCharge) : ''}</span>
												{!edit && !disabled && <button
													className='btn-close'
													style={{width: 13, height: 13, padding: 0}}
													onClick={() => {
														onChange(value.projs.filter((v) => v.id !== proj.id), value.id || value.key, 'projs')
														onChange(value.personsInCharge.filter(person => person.projId !== proj.id), value.id || value.key, 'personsInCharge')
													}}
												/>}
											</p>
										</li>
									})
									}
								</ul>
							</div>
						}
						{!edit && <Col className='d-flex gap-3'>
							<Button
								variant='outline-primary'
								onClick={() => setPersonInChargeModalShow(true)}
								variant={value.projs.some(proj => proj.selected) ? 'outline-secondary' : 'outline-primary'}
								disabled={value.projs.some(proj => proj.selected) || disabled}
							>
								<PlusLg /> Назначить ответственного <Required />
							</Button>
							<Button
								onClick={() => setImpactProjectsModalShow(true)}
								variant={value.personsInCharge.some(person => person.selected) ? 'outline-secondary' : 'outline-primary'}
								disabled={value.personsInCharge.some(person => person.selected) || disabled}
							>
								<PlusLg /> Проекты, влияющие на выполнение результата
							</Button>
							{((value.personsInCharge && !value.personsInCharge.every((person) => !person.selected)) ||
									(value.projs && !value.projs.every((project) => !project.selected))) &&
								<Button
									variant='outline-danger'
									onClick={() => {
										const filteredProjects = value.projs.filter((project) => !project.selected)
										onChange(filteredProjects, value.id || value.key, 'projs')
										onChange(value.personsInCharge.filter((person) => !person.selected && (!person.projId || filteredProjects.some(proj => proj.id === person.projId))), value.id || value.key, 'personsInCharge')
									}}
									disabled={disabled}
								>
									Очистить текущий выбор
								</Button>}
						</Col>}
					</Row>
					{!edit && !disabled ? (
						<Row className={style.rowResult}>
							<Form.Group as={Col}>
								<Form.Label>Документы</Form.Label>
								<FileInput
									customState
									downloadble
									isStratPage
									onDeleteFile={id => onDeleteFile(id, value?.id)}
									fileList={value.files.filter(
										x => x?.isPlan === true || !x?.id
									)}
									onFileChange={newFiles =>
										onChange([...newFiles], value.id || value.key, 'files')
									}
									className={style.fileInputResults}
								/>
							</Form.Group>
						</Row>
					) : (
						<Row className={style.rowResult}>
							<Form.Group as={Col}>
								<Form.Label>Документы</Form.Label>
								{value.files &&
									value.files
										.filter(x => x?.isPlan === true)
										.map((x, y) => (
											<FileView index={y} item={x} disabled isDownloadable />
										))}
							</Form.Group>
						</Row>
					)}
					{edit && <Row>
						<Form.Group as={Col} className='my-4'>
							<Form.Label>Описание выполнения результата <Required/></Form.Label>
							<Form.Control
								as={'textarea'}
								disabled={projectDisabledStatus || options.mileStoneId}
								style={{width: '100%'}}
								name='result'
								rows={4}
								defaultValue={
									value.result ||
									(
										value.projMilestones && value.projMilestones.length > 0 ?
											'В проектах, в которые назначен данный результат, заполнены факты:\n' + value.projMilestones.filter(milestone => !!milestone.result).map((milestone, i) => `${milestone.projs[0].fullNumber}. ${milestone.result}`).join('\n') :
											''
									)
								}
								required
								onChange={(e) => {
									onChange(e.target.value, value.id || value.key, e.target.name)
								}}
							/>
						</Form.Group>
						{value.projs?.length > 0 && value.projMilestones?.length > 0 && <Row className={style.projectFacts}>
							<h2>Фактическое значение по вехам проектов</h2>
							<ProjectsFacts activeMilestoneSetter={setActiveMilestone} projectFacts={value.projMilestones}/>
						</Row>}
					</Row>}
					{edit ? (
						!projectDisabledStatus && !options.mileStoneId ? (
							<Row className={style.rowResult}>
								<Form.Group as={Col}>
									<Form.Label>Подтверждающие результат документы</Form.Label>
									<FileInput
										customState
										downloadble
										isStratPage
										onDeleteFile={id => onDeleteFile(id, value?.id)}
										fileList={value.files.filter(
											x => x?.isPlan === false || !x?.id
										)}
										onFileChange={newFiles =>
											onChange([...newFiles], value.id || value.key, 'files')
										}
										className={style.fileInputResults}
									/>
								</Form.Group>
							</Row>
						) : (
							<Row className={style.rowResult}>
								<Form.Group as={Col}>
									<Form.Label>Подтверждающие результат документы</Form.Label>
									{value.files &&
										value.files
											.filter(x => x?.isPlan === false)
											.map((x, y) => (
												<FileView index={y} item={x} isDownloadable disabled />
											))}
								</Form.Group>
							</Row>
						)
					) : (
						<></>
					)}


					<HorizontalDivider />
					{(value.milestones || [])
						.slice()
						.filter(milestone => !milestone.yearPlan || milestone.yearPlan >= 2023)
						.sort((x, y) => Number(x.orderNum) - Number(y.orderNum))
						.map(
							(x, y) =>
								(options.mileStoneId === 0 ||
									!edit ||
									(!!Number(options.mileStoneId) &&
										x.id === +options.mileStoneId)) && (
									<MileStoneEdit
										key={x?.id || x?.key}
										blocked={!options.mileStoneId}
										edit={edit}
										options={{
											ygt: options.ygt,
											responsibleOpt: options.getOptions,
											num: +x?.num,
										}}
										onDelete={() => handleDeleteMileStone(x)}
										index={y}
										onChange={handleUpdateMileStone}
										value={x}
										onDeleteFile={id => x.id && onDeleteFile(id, x?.id)}
										userCtx={userCtx}
										projects={projects}
										closedPeriods={closedPeriods}
									/>
								)
						)}
					{!edit && (
						<Row>
							<Col className='col-sm-2'>
								<Button
									variant='outline-primary'
									onClick={() => {
										handleAddMileStone()
									}}
									disabled={disabled}
								>
									+ Добавить веху
								</Button>
							</Col>
						</Row>
					)}
				</Card.Body>
			</Card>
			<ConfirmModal
				show={confirmModalOpen}
				onConfirm={() => onDelete()}
				onClose={() => setConfirmModalOpen(!confirmModalOpen)}
				message='Данный результат будет удален. Вы уверены ?'
			/>
			<PersonsInChargeModal
				show={personsInChargeModalShow}
				onHide={() => setPersonInChargeModalShow(false)}
				onSave={values => onChange(values, value.id || value.key, 'personsInCharge')}
				value={value}
			/>
			<ImpactProjectsModal
				show={impactProjectsModalShow}
				onHide={() => setImpactProjectsModalShow(false)}
				onSave={values => {
					onChange(values, value.id || value.key, 'projs')
					onChange([
						...value.personsInCharge.filter(person => {
							const filterValues = filterPersonWithProjects(person, values)
							return filterValues.inProjectsWithProjId || filterValues.notContainsWithoutProjId
						}),
						...values.filter(value => value.selected).map(proj => ({...proj.head, projId: proj.id}))
					], value.id || value.key, 'personsInCharge')
				}}
				value={value}
				projects={projects}
				isForResult
			/>
			<MilestoneFilesModal
				show={!!activeMilestone}
				onHide={() => setActiveMilestone(null)}
				files={activeMilestone?.files || []}
			/>
		</>
	)
});

